/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Form_H2Inputs */

const es_ab_form_h2 = /** @type {(inputs: Ab_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra tu barco en Zarpar`)
};

const gl_ab_form_h2 = /** @type {(inputs: Ab_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexistra o teu barco en Zarpar`)
};

const en_ab_form_h2 = /** @type {(inputs: Ab_Form_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register your boat on Zarpar`)
};

/**
* | output |
* | --- |
* | "Register your boat on Zarpar" |
*
* @param {Ab_Form_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_form_h2 = /** @type {((inputs?: Ab_Form_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Form_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_form_h2(inputs)
	if (locale === "en") return en_ab_form_h2(inputs)
	return es_ab_form_h2(inputs)
});